import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUsuarioLogado, isLoggedIn, apiCall, getAuthToken } from '../utils/auth';
import '../sidebar/MinhaConta.css';
import './CadastrarUsuario.css';
import LoadingOverlay from './LoadingOverlay';// Helper para headers autenticados
import BASE_URL from '../utils/api';
const authHeaders = (extra = {}) => {
  const token = getAuthToken();
  const h = { ...extra };
  if (token) h['Authorization'] = `Bearer ${token}`;
  return h;
};

// IDs de Nível de Funcionário (TipoUsuarioLogin)
const NIVEL_GERENTE_TI = 6;
const NIVEL_GERENTE = 3;

// Lista de páginas do sistema para controle de acesso (sem Cadastrar/Gerenciar Funcionários - tratados separadamente)
const PAGINAS_SISTEMA = [
  { nome: 'Cliente', label: 'Clientes' },
  { nome: 'Fornecedor', label: 'Fornecedores' },
  { nome: 'Pessoas', label: 'Pessoas' },
  { nome: 'Agendamentos', label: 'Agendamentos' },
  { nome: 'Calendario', label: 'Calendário' },
  { nome: 'Oportunidade', label: 'Oportunidades' },
  { nome: 'Orcamento', label: 'Orçamentos' },
  { nome: 'Contrato', label: 'Contratos' },
  { nome: 'Vendas', label: 'Vendas' },
  { nome: 'VendasProdutos', label: 'Vendas de Produtos' },
  { nome: 'ContasPagar', label: 'Contas a Pagar' },
  { nome: 'ContasReceber', label: 'Contas a Receber' },
  { nome: 'NotaFiscal', label: 'Notas Fiscais' },
  { nome: 'Producao', label: 'Projeto' },
  { nome: 'ProjetoVisual', label: 'Projeto Visual' },
  { nome: 'Tarefas', label: 'Tarefas' },
  { nome: 'MateriaPrima', label: 'Matéria Prima' },
  { nome: 'ServicosTerceiros', label: 'Serviços de Terceiros' },
  { nome: 'Manutencao', label: 'Manutenção' },
  { nome: 'Garantia', label: 'Garantia' },
  { nome: 'RelacionamentoClientes', label: 'Relacionamento com Clientes' },
  { nome: 'EntregasProdutos', label: 'Entrega de Produtos' },
  { nome: 'EntregasServicos', label: 'Entrega de Serviços' },
  { nome: 'Prazos', label: 'Prazos' },
  { nome: 'Estoque', label: 'Estoque' },
  { nome: 'Produto', label: 'Produtos' },
  { nome: 'Grupo', label: 'Grupos' },
];

// Páginas especiais de gerenciamento de funcionários (só Gerente de TI)
const PAGINAS_FUNCIONARIOS = [
  { nome: 'CadastrarUsuario', label: 'Cadastrar Funcionários' },
  { nome: 'GerenciarFuncionarios', label: 'Gerenciar Funcionários' },
];

export default function GerenciarFuncionarios() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingTipos, setLoadingTipos] = useState(false);
  const [loadingNiveis, setLoadingNiveis] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  // Dados do usuário logado
  const [usuarioLogado, setUsuarioLogado] = useState(null);
  
  // Lista de funcionários
  const [funcionarios, setFuncionarios] = useState([]);
  const [loadingFuncionarios, setLoadingFuncionarios] = useState(false);
  
  // Lista de tipos de usuário (cargo)
  const [tiposUsuario, setTiposUsuario] = useState([]);
  
  // Lista de níveis de funcionário
  const [niveisUsuario, setNiveisUsuario] = useState([]);
  
  // Popups
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showPasswordPopup, setShowPasswordPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  
  // Funcionário selecionado para edição
  const [selectedFuncionario, setSelectedFuncionario] = useState(null);
  const [dadosUsuarioSelecionado, setDadosUsuarioSelecionado] = useState(null);
  
  // Form data para edição
  const [editFormData, setEditFormData] = useState({
    login: '',
    cpfEmpregado: '',
    tipoUsuarioId: '',
    tipoUsuarioLoginId: '',
    nomeUsuario: '',
    email: '',
    telefone: ''
  });

  // Permissões de páginas (controle de acesso)
  const [paginasSelecionadas, setPaginasSelecionadas] = useState(
    PAGINAS_SISTEMA.reduce((acc, pagina) => ({ ...acc, [pagina.nome]: true }), {})
  );
  const [todosSelecionados, setTodosSelecionados] = useState(true);
  const [loadingPermissoes, setLoadingPermissoes] = useState(false);
  
  // Permissões de páginas de funcionários (para Gerente não TI)
  const [permissoesFuncionarios, setPermissoesFuncionarios] = useState({
    CadastrarUsuario: false,
    GerenciarFuncionarios: false
  });
  
  // Form data para senha
  const [passwordFormData, setPasswordFormData] = useState({
    novaSenha: '',
    confirmarSenha: ''
  });
  const [showPassword, setShowPassword] = useState(false);

  // Carregar dados do usuário logado
  useEffect(() => {
    if (isLoggedIn()) {
      const user = getUsuarioLogado();
      setUsuarioLogado(user);
    }
  }, []);

  // Carregar tipos de usuário (cargo)
  const carregarTiposUsuario = useCallback(async () => {
    try {
      setLoadingTipos(true);
      const tipos = await apiCall('TipoUsuario');
      setTiposUsuario(Array.isArray(tipos) ? tipos : []);
    } catch (err) {
      console.error('Erro ao carregar tipos de usuário:', err);
    } finally {
      setLoadingTipos(false);
    }
  }, []);

  // Carregar níveis de funcionário
  const carregarNiveisUsuario = useCallback(async () => {
    try {
      setLoadingNiveis(true);
      const niveis = await apiCall('TipoUsuarioLogin');
      const niveisFiltrados = Array.isArray(niveis) 
        ? niveis.filter(n => n.id !== 5 && n.Id !== 5)
        : [];
      setNiveisUsuario(niveisFiltrados);
    } catch (err) {
      console.error('Erro ao carregar níveis de usuário:', err);
    } finally {
      setLoadingNiveis(false);
    }
  }, []);

  // Carregar funcionários vinculados
  const carregarFuncionarios = useCallback(async () => {
    if (!usuarioLogado) {
      console.log('❌ Usuário não logado');
      return;
    }
    
    console.log('🔍 Carregando funcionários para:', usuarioLogado);
    
    try {
      setLoadingFuncionarios(true);
      
      // Buscar diretamente do banco usando o CNPJ ou CPF
      // Como os endpoints por-cnpj e por-cpf retornam apenas 1 usuário,
      // vamos usar uma abordagem: buscar pela tabela UsuarioSistema
      
      let funcionariosEncontrados = [];
      
      if (usuarioLogado.tipoPessoa === 'PJ' && usuarioLogado.cnpjUsuario) {
        console.log('🏢 Buscando funcionários PJ com CNPJ:', usuarioLogado.cnpjUsuario);
        
        // Tentar buscar todos os usuários (se existir endpoint GetAll)
        try {
          const response = await fetch(`${BASE_URL}/UsuarioSistema`, { headers: authHeaders() });
          console.log('📡 Response status:', response.status);
          
          if (response.ok) {
            const allUsers = await response.json();
            console.log('👥 Todos usuários:', allUsers);
            
            // Filtrar funcionários com mesmo CNPJ e que tenham CPFEmpregado
            funcionariosEncontrados = allUsers.filter(u => 
              u.cnpjUsuario === usuarioLogado.cnpjUsuario &&
              u.cpfEmpregado &&
              u.id !== usuarioLogado.id
            );
            console.log('✅ Funcionários filtrados:', funcionariosEncontrados);
          }
        } catch (err) {
          console.error('❌ Erro ao buscar todos usuários:', err);
        }
      } else if (usuarioLogado.tipoPessoa === 'PF' && usuarioLogado.cpfUsuario) {
        console.log('👤 Buscando funcionários PF com CPF:', usuarioLogado.cpfUsuario);
        
        // Tentar buscar todos os usuários
        try {
          const response = await fetch(`${BASE_URL}/UsuarioSistema`, { headers: authHeaders() });
          console.log('📡 Response status:', response.status);
          
          if (response.ok) {
            const allUsers = await response.json();
            console.log('👥 Todos usuários:', allUsers);
            
            // Filtrar funcionários com mesmo CPF e que tenham CPFEmpregado
            funcionariosEncontrados = allUsers.filter(u => 
              u.cpfUsuario === usuarioLogado.cpfUsuario &&
              u.cpfEmpregado &&
              u.id !== usuarioLogado.id
            );
            console.log('✅ Funcionários filtrados:', funcionariosEncontrados);
          }
        } catch (err) {
          console.error('❌ Erro ao buscar todos usuários:', err);
        }
      }
      
      setFuncionarios(funcionariosEncontrados);
      console.log('📊 Total de funcionários:', funcionariosEncontrados.length);
      
    } catch (err) {
      console.error('❌ Erro ao carregar funcionários:', err);
      setFuncionarios([]);
    } finally {
      setLoadingFuncionarios(false);
    }
  }, [usuarioLogado]);

  useEffect(() => {
    carregarTiposUsuario();
    carregarNiveisUsuario();
  }, [carregarTiposUsuario, carregarNiveisUsuario]);

  useEffect(() => {
    carregarFuncionarios();
  }, [carregarFuncionarios]);

  // Ref para acesso aos funcionários dentro de event listeners do tour
  const funcionariosRef = React.useRef([]);
  useEffect(() => { funcionariosRef.current = funcionarios; }, [funcionarios]);

  // Tour: abrir popup de edição do primeiro funcionário disponível
  useEffect(() => {
    const openEditHandler = () => {
      const list = funcionariosRef.current;
      if (list.length > 0) {
        // Abre edição do primeiro funcionário sem fetch (para não depender de rede)
        const func = list[0];
        setSelectedFuncionario(func);
        setError('');
        setSuccess('');
        setEditFormData({
          login: func.login || '',
          cpfEmpregado: func.cpfEmpregado || '',
          tipoUsuarioId: String(func.tipoUsuarioId || ''),
          tipoUsuarioLoginId: String(func.tipoUsuarioLoginId || NIVEL_GERENTE),
          nomeUsuario: '',
          email: '',
          telefone: '',
        });
        setPaginasSelecionadas(PAGINAS_SISTEMA.reduce((acc, p) => ({ ...acc, [p.nome]: true }), {}));
        setTodosSelecionados(true);
        setPermissoesFuncionarios({ CadastrarUsuario: false, GerenciarFuncionarios: false });
        setShowEditPopup(true);
      } else {
        // Sem funcionários: abrir popup vazio com Gerente pre-selecionado
        setEditFormData(prev => ({ ...prev, tipoUsuarioLoginId: String(NIVEL_GERENTE) }));
        setShowEditPopup(true);
      }
    };

    const setNivelGerenteHandler = () => {
      setEditFormData(prev => ({ ...prev, tipoUsuarioLoginId: String(NIVEL_GERENTE) }));
    };

    window.addEventListener('tour-open-edit-gerenciar', openEditHandler);
    window.addEventListener('tour-set-nivel-gerente-gerenciar', setNivelGerenteHandler);
    return () => {
      window.removeEventListener('tour-open-edit-gerenciar', openEditHandler);
      window.removeEventListener('tour-set-nivel-gerente-gerenciar', setNivelGerenteHandler);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  const carregarPermissoesFuncionario = async (usuarioId, nivelId) => {
    try {
      setLoadingPermissoes(true);
      const response = await fetch(`${BASE_URL}/PaginaSistema/por-usuario/${usuarioId}`, { headers: authHeaders() });
      
      if (response.ok) {
        const permissoes = await response.json();
        const paginasLiberadas = permissoes.map(p => p.nome || p.Nome);
        
        // Criar objeto com as páginas marcadas
        const novasPaginasSelecionadas = PAGINAS_SISTEMA.reduce((acc, pagina) => ({
          ...acc,
          [pagina.nome]: paginasLiberadas.includes(pagina.nome)
        }), {});
        
        setPaginasSelecionadas(novasPaginasSelecionadas);
        
        // Verificar se todos estão selecionados
        const todosMarcados = PAGINAS_SISTEMA.every(p => novasPaginasSelecionadas[p.nome]);
        setTodosSelecionados(todosMarcados);
        
        // Carregar permissões de funcionários (para Gerentes)
        const nivel = parseInt(nivelId, 10);
        if (nivel === NIVEL_GERENTE) {
          const novasPermissoesFuncionarios = {
            CadastrarUsuario: paginasLiberadas.includes('CadastrarUsuario'),
            GerenciarFuncionarios: paginasLiberadas.includes('GerenciarFuncionarios')
          };
          setPermissoesFuncionarios(novasPermissoesFuncionarios);
        } else {
          setPermissoesFuncionarios({
            CadastrarUsuario: false,
            GerenciarFuncionarios: false
          });
        }
        
        console.log('✅ Permissões carregadas:', paginasLiberadas);
      } else {
        // Se não encontrou permissões, considera todos marcados (padrão)
        resetarPermissoes();
      }
    } catch (err) {
      console.error('Erro ao carregar permissões:', err);
      resetarPermissoes();
    } finally {
      setLoadingPermissoes(false);
    }
  };

  // Função para marcar/desmarcar uma página específica
  const handlePaginaChange = (nomePagina) => {
    const nivelSelecionado = parseInt(editFormData.tipoUsuarioLoginId, 10);
    // Apenas Gerente de TI não pode alterar (Gerente pode)
    if (nivelSelecionado === NIVEL_GERENTE_TI) {
      return;
    }
    
    setPaginasSelecionadas(prev => {
      const novoEstado = { ...prev, [nomePagina]: !prev[nomePagina] };
      const todosMarcados = PAGINAS_SISTEMA.every(p => novoEstado[p.nome]);
      setTodosSelecionados(todosMarcados);
      return novoEstado;
    });
  };

  // Função para marcar/desmarcar todos
  const handleTodosChange = () => {
    const nivelSelecionado = parseInt(editFormData.tipoUsuarioLoginId, 10);
    // Apenas Gerente de TI não pode alterar (Gerente pode)
    if (nivelSelecionado === NIVEL_GERENTE_TI) {
      return;
    }
    
    const novoValor = !todosSelecionados;
    setTodosSelecionados(novoValor);
    setPaginasSelecionadas(
      PAGINAS_SISTEMA.reduce((acc, pagina) => ({ ...acc, [pagina.nome]: novoValor }), {})
    );
  };

  // Função para marcar/desmarcar permissões de funcionários (apenas Gerente)
  const handlePermissaoFuncionarioChange = (nomePagina) => {
    setPermissoesFuncionarios(prev => ({
      ...prev,
      [nomePagina]: !prev[nomePagina]
    }));
  };

  // Atualizar permissões quando o nível do funcionário mudar na edição
  const atualizarPermissoesPorNivelEdit = (nivelId) => {
    const nivel = parseInt(nivelId, 10);
    
    if (nivel === NIVEL_GERENTE_TI || nivel === NIVEL_GERENTE) {
      // Gerente de TI e Gerente: tudo marcado
      setTodosSelecionados(true);
      setPaginasSelecionadas(
        PAGINAS_SISTEMA.reduce((acc, pagina) => ({ ...acc, [pagina.nome]: true }), {})
      );
    }
    
    // Resetar permissões de funcionários
    setPermissoesFuncionarios({
      CadastrarUsuario: false,
      GerenciarFuncionarios: false
    });
  };

  // Resetar permissões para o padrão (todos marcados)
  const resetarPermissoes = () => {
    setTodosSelecionados(true);
    setPaginasSelecionadas(
      PAGINAS_SISTEMA.reduce((acc, pagina) => ({ ...acc, [pagina.nome]: true }), {})
    );
    setPermissoesFuncionarios({
      CadastrarUsuario: false,
      GerenciarFuncionarios: false
    });
  };

  // Obter descrição do cargo
  const getTipoUsuarioDescricao = (tipoId) => {
    const tipo = tiposUsuario.find(t => (t.id || t.Id) === tipoId);
    return tipo?.descricaoTpUsuario || tipo?.DescricaoTpUsuario || 'N/A';
  };

  // Obter descrição do nível
  const getNivelUsuarioDescricao = (nivelId) => {
    const nivel = niveisUsuario.find(n => (n.id || n.Id) === nivelId);
    return nivel?.descricao || nivel?.Descricao || 'N/A';
  };

  // Abrir popup de edição
  const handleOpenEdit = async (funcionario) => {
    setSelectedFuncionario(funcionario);
    setError('');
    setSuccess('');
    
    // Buscar DadosUsuario
    try {
      const response = await fetch(`${BASE_URL}/DadosUsuario/por-usuario/${funcionario.id}`, { headers: authHeaders() });
      let dadosUsuario = null;
      if (response.ok) {
        dadosUsuario = await response.json();
      }
      setDadosUsuarioSelecionado(dadosUsuario);
      
      setEditFormData({
        login: funcionario.login || '',
        cpfEmpregado: funcionario.cpfEmpregado || '',
        tipoUsuarioId: String(funcionario.tipoUsuarioId || ''),
        tipoUsuarioLoginId: String(funcionario.tipoUsuarioLoginId || ''),
        nomeUsuario: dadosUsuario?.nomeUsuario || dadosUsuario?.NomeUsuario || '',
        email: dadosUsuario?.email || dadosUsuario?.Email || '',
        telefone: dadosUsuario?.telefone || dadosUsuario?.Telefone || ''
      });
    } catch (err) {
      console.error('Erro ao carregar dados do usuário:', err);
      setEditFormData({
        login: funcionario.login || '',
        cpfEmpregado: funcionario.cpfEmpregado || '',
        tipoUsuarioId: String(funcionario.tipoUsuarioId || ''),
        tipoUsuarioLoginId: String(funcionario.tipoUsuarioLoginId || ''),
        nomeUsuario: '',
        email: '',
        telefone: ''
      });
    }
    
    // Carregar permissões do funcionário
    await carregarPermissoesFuncionario(funcionario.id, funcionario.tipoUsuarioLoginId);
    
    setShowEditPopup(true);
  };

  // Abrir popup de senha
  const handleOpenPassword = (funcionario) => {
    setSelectedFuncionario(funcionario);
    setPasswordFormData({ novaSenha: '', confirmarSenha: '' });
    setShowPassword(false);
    setError('');
    setSuccess('');
    setShowPasswordPopup(true);
  };

  // Abrir popup de exclusão
  const handleOpenDelete = (funcionario) => {
    setSelectedFuncionario(funcionario);
    setError('');
    setShowDeletePopup(true);
  };

  // Fechar popups
  const handleClosePopups = () => {
    setShowEditPopup(false);
    setShowPasswordPopup(false);
    setShowDeletePopup(false);
    setSelectedFuncionario(null);
    setDadosUsuarioSelecionado(null);
    setError('');
    setSuccess('');
  };

  // Handle edit form change
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    
    // Quando mudar o nível do funcionário, atualizar permissões
    if (name === 'tipoUsuarioLoginId') {
      atualizarPermissoesPorNivelEdit(value);
    }
    
    setEditFormData(prev => ({ ...prev, [name]: value }));
  };

  // Handle password form change
  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    // Proibir espaços
    const cleanValue = value.replace(/\s/g, '');
    setPasswordFormData(prev => ({ ...prev, [name]: cleanValue }));
  };

  // Validação de senha
  const passwordRules = (pwd) => {
    const rules = [
      { id: 'length', label: 'Mínimo 6 caracteres', ok: pwd && pwd.length >= 6 },
      { id: 'composition', label: 'Contém letras, números e caractere especial', ok: pwd && /[A-Za-z]/.test(pwd) && /\d/.test(pwd) && /[^A-Za-z0-9]/.test(pwd) },
    ];
    return rules;
  };

  // Salvar edição
  const handleSaveEdit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!editFormData.tipoUsuarioId) {
      setError('Selecione o cargo do funcionário.');
      return;
    }

    if (!editFormData.tipoUsuarioLoginId) {
      setError('Selecione o nível do funcionário.');
      return;
    }

    if (!editFormData.nomeUsuario || !editFormData.email) {
      setError('Nome e email são obrigatórios.');
      return;
    }

    setLoading(true);

    try {
      // PUT UsuarioSistema
      const usuarioPayload = {
        id: selectedFuncionario.id,
        login: selectedFuncionario.login,
        senhaHash: selectedFuncionario.senhaHash,
        tipoPessoa: selectedFuncionario.tipoPessoa,
        cpfUsuario: selectedFuncionario.cpfUsuario,
        cnpjUsuario: selectedFuncionario.cnpjUsuario,
        cpfEmpregado: selectedFuncionario.cpfEmpregado,
        tipoUsuarioId: parseInt(editFormData.tipoUsuarioId, 10),
        tipoUsuarioLoginId: parseInt(editFormData.tipoUsuarioLoginId, 10)
      };

      const respUsuario = await fetch(`${BASE_URL}/UsuarioSistema/${selectedFuncionario.id}`, {
        method: 'PUT',
        headers: authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(usuarioPayload)
      });

      if (!respUsuario.ok) {
        const text = await respUsuario.text();
        throw new Error(text || 'Erro ao atualizar usuário');
      }

      // PUT ou POST DadosUsuario
      const dadosPayload = {
        usuarioSistemaId: selectedFuncionario.id,
        nomeUsuario: editFormData.nomeUsuario,
        email: editFormData.email,
        telefone: editFormData.telefone || ''
      };

      if (dadosUsuarioSelecionado?.id || dadosUsuarioSelecionado?.Id) {
        // PUT
        const dadosId = dadosUsuarioSelecionado.id || dadosUsuarioSelecionado.Id;
        dadosPayload.id = dadosId;
        await fetch(`${BASE_URL}/DadosUsuario/${dadosId}`, {
          method: 'PUT',
          headers: authHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(dadosPayload)
        });
      } else {
        // POST
        await fetch(`${BASE_URL}/DadosUsuario`, {
          method: 'POST',
          headers: authHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(dadosPayload)
        });
      }

      // Atualizar permissões de acesso às páginas
      // Primeiro, deletar permissões antigas
      await fetch(`${BASE_URL}/PaginaSistema/por-usuario/${selectedFuncionario.id}`, {
        method: 'DELETE',
        headers: authHeaders()
      });

      // Depois, criar novas permissões
      let paginasLiberadas = PAGINAS_SISTEMA
        .filter(pagina => paginasSelecionadas[pagina.nome])
        .map(pagina => pagina.nome);

      // Se for Gerente de TI, adicionar páginas de funcionários
      const nivelSelecionado = parseInt(editFormData.tipoUsuarioLoginId, 10);
      if (nivelSelecionado === NIVEL_GERENTE_TI) {
        paginasLiberadas = [...paginasLiberadas, ...PAGINAS_FUNCIONARIOS.map(p => p.nome)];
      } else if (nivelSelecionado === NIVEL_GERENTE) {
        // Gerente: adicionar apenas as páginas de funcionários que foram selecionadas
        const paginasFuncionariosSelecionadas = PAGINAS_FUNCIONARIOS
          .filter(p => permissoesFuncionarios[p.nome])
          .map(p => p.nome);
        paginasLiberadas = [...paginasLiberadas, ...paginasFuncionariosSelecionadas];
      }

      if (paginasLiberadas.length > 0) {
        const permissoesPayload = {
          paginas: paginasLiberadas,
          usuarioSistemaId: selectedFuncionario.id
        };

        console.log('📤 Atualizando permissões:', permissoesPayload);

        const respPermissoes = await fetch(`${BASE_URL}/PaginaSistema/bulk`, {
          method: 'POST',
          headers: authHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(permissoesPayload)
        });

        if (!respPermissoes.ok) {
          const text = await respPermissoes.text();
          console.warn('Aviso ao atualizar permissões:', text);
        } else {
          console.log('✅ Permissões atualizadas com sucesso!');
        }
      }

      setSuccess('Funcionário atualizado com sucesso!');
      setTimeout(() => {
        carregarFuncionarios();
        handleClosePopups();
      }, 1500);

    } catch (err) {
      console.error('Erro ao atualizar:', err);
      setError('Erro ao atualizar: ' + (err.message || String(err)));
    } finally {
      setLoading(false);
    }
  };

  // Alterar senha
  const handleSavePassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    const rules = passwordRules(passwordFormData.novaSenha);
    const validPassword = rules.every(r => r.ok);

    if (!validPassword) {
      setError('A senha não atende aos requisitos.');
      return;
    }

    if (passwordFormData.novaSenha !== passwordFormData.confirmarSenha) {
      setError('As senhas não coincidem.');
      return;
    }

    setLoading(true);

    try {
      // PATCH /senha — altera APENAS no banco CENTRAL, não toca na instância
      const respSenha = await fetch(`${BASE_URL}/UsuarioSistema/${selectedFuncionario.id}/senha`, {
        method: 'PATCH',
        headers: authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ NovaSenha: passwordFormData.novaSenha })
      });

      if (!respSenha.ok) {
        const text = await respSenha.text();
        throw new Error(text || 'Erro ao alterar senha');
      }

      setSuccess('Senha alterada com sucesso!');
      setTimeout(() => {
        handleClosePopups();
      }, 1500);

    } catch (err) {
      console.error('Erro ao alterar senha:', err);
      setError('Erro ao alterar senha: ' + (err.message || String(err)));
    } finally {
      setLoading(false);
    }
  };

  // Excluir funcionário
  const handleConfirmDelete = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${BASE_URL}/UsuarioSistema/${selectedFuncionario.id}`, {
        method: 'DELETE',
        headers: authHeaders()
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Erro ao excluir funcionário');
      }

      setSuccess('Funcionário excluído com sucesso!');
      setTimeout(() => {
        carregarFuncionarios();
        handleClosePopups();
      }, 1500);

    } catch (err) {
      console.error('Erro ao excluir:', err);
      setError('Erro ao excluir: ' + (err.message || String(err)));
    } finally {
      setLoading(false);
    }
  };

  if (!isLoggedIn()) {
    return (
      <div className="minha-conta-container">
        <div className="minha-conta-card">
          <p>Você precisa estar logado para acessar esta página.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="cadastrar-usuario-container" style={{ position: 'relative' }}>
      <LoadingOverlay isLoading={loading} message="Processando..." />
      
      <button
        onClick={() => navigate('/sidebar/Configuracoes')}
        className="planos-btn-voltar"
        style={{ position: 'absolute', top: 10, left: 10, zIndex: 20 }}
        title="Voltar para Configurações"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        Voltar
      </button>
      <div className="cadastrar-usuario-card">
        <div className="cadastrar-usuario-header">
          <h2>Gerenciar Funcionários</h2>
          <p>Edite e gerencie as contas dos seus funcionários</p>
        </div>

        <button
          onClick={() => navigate('/sidebar/CadastrarUsuario')}
          style={{
            background: 'rgb(235, 133, 0)',
            color: 'white',
            border: 'none',
            borderRadius: 10,
            padding: '12px 24px',
            fontWeight: 700,
            fontSize: 15,
            cursor: 'pointer',
            marginBottom: 24,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            boxShadow: '0 2px 8px rgba(235, 133, 0,0.3)',
            transition: 'background 0.2s',
          }}
          onMouseEnter={e => e.currentTarget.style.background = '#fb8c00'}
          onMouseLeave={e => e.currentTarget.style.background = 'rgb(235, 133, 0)'}
        >
          <span style={{ fontSize: 18 }}>+</span>
          Cadastrar Novo Funcionário
        </button>

        {/* Lista de Funcionários */}
        <div className="funcionarios-section">
          <h3 style={{ marginBottom: 20, color: '#1e2a4a' }}>Funcionários Cadastrados</h3>
          
          {loadingFuncionarios ? (
            <p className="loading-text">Carregando funcionários...</p>
          ) : funcionarios.length === 0 ? (
            <p className="empty-text">Nenhum funcionário cadastrado ainda.</p>
          ) : (
            <div style={{ display: 'grid', gap: 18 }}>
              {funcionarios.map(func => (
                <div 
                  key={func.id} 
                  style={{
                    background: 'white',
                    borderRadius: 14,
                    boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
                    padding: 24,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 16
                  }}
                >
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16 }}>
                    <div>
                      <span style={{ color: '#888', fontSize: 13, fontWeight: 500 }}>Login</span>
                      <div style={{ fontWeight: 600, fontSize: 16, color: '#1e2a4a' }}>{func.login || 'Sem login'}</div>
                    </div>
                    <div>
                      <span style={{ color: '#888', fontSize: 13, fontWeight: 500 }}>CPF</span>
                      <div style={{ fontWeight: 600, fontSize: 16, color: '#1e2a4a' }}>{func.cpfEmpregado || 'N/A'}</div>
                    </div>
                    <div>
                      <span style={{ color: '#888', fontSize: 13, fontWeight: 500 }}>Cargo</span>
                      <div style={{ fontWeight: 600, fontSize: 16, color: '#1e2a4a' }}>{getTipoUsuarioDescricao(func.tipoUsuarioId)}</div>
                    </div>
                    <div>
                      <span style={{ color: '#888', fontSize: 13, fontWeight: 500 }}>Nível de Acesso</span>
                      <div style={{ fontWeight: 600, fontSize: 16, color: '#1e2a4a' }}>{getNivelUsuarioDescricao(func.tipoUsuarioLoginId)}</div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 8 }}>
                    <button 
                      onClick={() => handleOpenPassword(func)}
                      title="Alterar Senha"
                      style={{
                        background: '#f39c12',
                        color: 'white',
                        border: 'none',
                        borderRadius: 8,
                        padding: '10px 18px',
                        fontWeight: 600,
                        fontSize: 14,
                        cursor: 'pointer',
                        transition: 'background 0.2s'
                      }}
                    >
                      Alterar Senha
                    </button>
                    <button 
                      onClick={() => handleOpenEdit(func)}
                      title="Editar"
                      style={{
                        background: '#f39c12',
                        color: 'white',
                        border: 'none',
                        borderRadius: 8,
                        padding: '10px 18px',
                        fontWeight: 600,
                        fontSize: 14,
                        cursor: 'pointer',
                        transition: 'background 0.2s'
                      }}
                    >
                      Editar
                    </button>
                    <button 
                      onClick={() => handleOpenDelete(func)}
                      title="Remover"
                      style={{
                        background: '#e74c3c',
                        color: 'white',
                        border: 'none',
                        borderRadius: 8,
                        padding: '10px 18px',
                        fontWeight: 600,
                        fontSize: 14,
                        cursor: 'pointer',
                        transition: 'background 0.2s'
                      }}
                    >
                      Remover
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Popup de Edição */}
      {showEditPopup && selectedFuncionario && (
        <div className="popup-overlay" onClick={handleClosePopups}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={handleClosePopups}>×</button>
            
            <div className="popup-header">
              <h3>Editar Funcionário</h3>
              <p>Atualize os dados do funcionário</p>
            </div>

            {error && <div className="popup-error">{error}</div>}
            {success && <div className="popup-success">{success}</div>}

            <form onSubmit={handleSaveEdit} className="popup-form">
              {/* Dados de Acesso (não editáveis) */}
              <div className="form-section">
                <h4>Dados de Acesso</h4>
                
                <div className="form-group">
                  <label htmlFor="login">Login</label>
                  <input 
                    id="login" 
                    name="login" 
                    value={editFormData.login} 
                    disabled={true}
                    className="input-disabled"
                  />
                  <small className="form-hint">Login não pode ser alterado</small>
                </div>

                <div className="form-group">
                  <label htmlFor="cpfEmpregado">CPF do Empregado</label>
                  <input 
                    id="cpfEmpregado" 
                    name="cpfEmpregado" 
                    value={editFormData.cpfEmpregado} 
                    onChange={handleEditChange}
                    placeholder="CPF do funcionário"
                    disabled={loading}
                  />
                </div>
              </div>

              {/* Perfil de Acesso */}
              <div className="form-section">
                <h4>Perfil de Acesso</h4>
                
                <div className="form-group">
                  <label htmlFor="tipoUsuarioId">Cargo Funcionário *</label>
                  <select 
                    id="tipoUsuarioId" 
                    name="tipoUsuarioId" 
                    value={editFormData.tipoUsuarioId} 
                    onChange={handleEditChange}
                    required 
                    disabled={loading || loadingTipos}
                  >
                    <option value="">Selecione o cargo...</option>
                    {tiposUsuario.map(tipo => {
                      const tipoId = tipo.id || tipo.Id;
                      const tipoDescricao = tipo.descricaoTpUsuario || tipo.DescricaoTpUsuario;
                      return (
                        <option key={tipoId} value={String(tipoId)}>
                          {tipoDescricao}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="tipoUsuarioLoginId">Nível Funcionário *</label>
                  <select 
                    id="tipoUsuarioLoginId" 
                    name="tipoUsuarioLoginId" 
                    value={editFormData.tipoUsuarioLoginId} 
                    onChange={handleEditChange}
                    required 
                    disabled={loading || loadingNiveis}
                  >
                    <option value="">Selecione o nível...</option>
                    {niveisUsuario.map(nivel => {
                      const nivelId = nivel.id || nivel.Id;
                      const nivelDescricao = nivel.descricao || nivel.Descricao;
                      return (
                        <option key={nivelId} value={String(nivelId)}>
                          {nivelDescricao}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>

              {/* Dados Pessoais */}
              <div className="form-section">
                <h4>Dados Pessoais</h4>
                
                <div className="form-group">
                  <label htmlFor="nomeUsuario">Nome Completo *</label>
                  <input 
                    id="nomeUsuario" 
                    name="nomeUsuario" 
                    value={editFormData.nomeUsuario} 
                    onChange={handleEditChange} 
                    placeholder="Nome do funcionário"
                    required 
                    disabled={loading} 
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">E-mail *</label>
                  <input 
                    id="email" 
                    name="email" 
                    type="email"
                    value={editFormData.email} 
                    onChange={handleEditChange} 
                    placeholder="email@exemplo.com"
                    required 
                    disabled={loading} 
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="telefone">Telefone</label>
                  <input 
                    id="telefone" 
                    name="telefone" 
                    value={editFormData.telefone} 
                    onChange={handleEditChange} 
                    placeholder="(00) 00000-0000"
                    disabled={loading} 
                  />
                </div>
              </div>

              {/* Permissões de Acesso às Páginas - só mostra após selecionar nível */}
              {editFormData.tipoUsuarioLoginId && (
                <div className="form-section">
                  <h4>🔐 Permissões de Acesso</h4>
                  
                  {loadingPermissoes ? (
                    <p style={{ color: '#888', fontStyle: 'italic' }}>Carregando permissões...</p>
                  ) : (
                    (() => {
                      const nivelSelecionado = parseInt(editFormData.tipoUsuarioLoginId, 10);
                      const isGerenteTI = nivelSelecionado === NIVEL_GERENTE_TI;
                      const isGerente = nivelSelecionado === NIVEL_GERENTE;
                      
                      return (
                        <>
                          <p style={{ fontSize: 13, color: '#333', marginBottom: 12 }}>
                            {isGerenteTI 
                              ? '✅ Gerente de TI: Acesso total a todas as páginas (não editável)'
                              : isGerente 
                                ? '✅ Gerente: Acesso total às páginas operacionais. Pode escolher acesso ao gerenciamento de funcionários.'
                                : 'Selecione as páginas que o funcionário poderá acessar no sistema'
                            }
                          </p>
                          
                          {/* Seção de Gerenciamento de Funcionários - Para Gerente de TI (bloqueado) e Gerente (editável) */}
                          {(isGerenteTI || isGerente) && (
                            <div style={{ marginBottom: 16 }}>
                              <h5 style={{ color: '#333', marginBottom: 8, fontSize: 14 }}>
                                🔧 Gerenciamento de Funcionários {isGerenteTI ? '(exclusivo Gerente de TI)' : '(opcional)'}
                              </h5>
                              <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                gap: 8,
                              }}>
                                {PAGINAS_FUNCIONARIOS.map(pagina => {
                                  const isChecked = isGerenteTI ? true : permissoesFuncionarios[pagina.nome];
                                  return (
                                    <div 
                                      key={pagina.nome}
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                        padding: '8px 10px',
                                        background: isChecked ? '#fff3e0' : 'white',
                                        borderRadius: 6,
                                        border: `1px solid ${isChecked ? '#ffcc80' : '#ddd'}`
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        id={`perm-func-edit-${pagina.nome}`}
                                        checked={isChecked}
                                        onChange={() => !isGerenteTI && handlePermissaoFuncionarioChange(pagina.nome)}
                                        disabled={loading || isGerenteTI}
                                        style={{ 
                                          width: 16, 
                                          height: 16, 
                                          cursor: isGerenteTI ? 'not-allowed' : 'pointer',
                                          accentColor: 'rgb(235, 133, 0)',
                                          filter: 'hue-rotate(0deg) brightness(1.1)'
                                        }}
                                      />
                                      <label 
                                        htmlFor={`perm-func-edit-${pagina.nome}`}
                                        style={{ 
                                          fontSize: 13, 
                                          color: '#333', 
                                          flex: 1,
                                          cursor: isGerenteTI ? 'not-allowed' : 'pointer',
                                          userSelect: 'none'
                                        }}
                                      >
                                        {pagina.label} {isGerenteTI && '✓'}
                                      </label>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                          
                          {/* Checkbox Todos */}
                          <div className="permissoes-todos" style={{ 
                            marginBottom: 16, 
                            padding: '10px 14px', 
                            background: todosSelecionados ? '#fff3e0' : 'white', 
                            borderRadius: 8,
                            border: `1px solid ${todosSelecionados ? '#ffcc80' : '#ddd'}`,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10
                          }}>
                            <input
                              type="checkbox"
                              id="todos-permissoes-edit"
                              checked={todosSelecionados}
                              onChange={handleTodosChange}
                              disabled={loading || isGerenteTI}
                              style={{ 
                                width: 18, 
                                height: 18, 
                                cursor: isGerenteTI ? 'not-allowed' : 'pointer',
                                accentColor: 'rgb(235, 133, 0)',
                                filter: 'hue-rotate(0deg) brightness(1.1)'
                              }}
                            />
                            <label 
                              htmlFor="todos-permissoes-edit" 
                              style={{ 
                                fontWeight: 600, 
                                color: '#333', 
                                cursor: isGerenteTI ? 'not-allowed' : 'pointer',
                                userSelect: 'none'
                              }}
                            >
                              Selecionar Todos {isGerenteTI && '(bloqueado)'}
                            </label>
                          </div>

                          {/* Grid de Permissões */}
                          <div className="permissoes-grid" style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                            gap: 8,
                            maxHeight: 280,
                            overflowY: 'auto',
                            padding: '8px 4px',
                            border: '1px solid #e0e0e0',
                            borderRadius: 8,
                            background: '#fafafa'
                          }}>
                            {PAGINAS_SISTEMA.map(pagina => (
                              <div 
                                key={pagina.nome}
                                className="permissao-item"
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 8,
                                  padding: '8px 10px',
                                  background: paginasSelecionadas[pagina.nome] ? '#fff3e0' : 'white',
                                  borderRadius: 6,
                                  border: `1px solid ${paginasSelecionadas[pagina.nome] ? '#ffcc80' : '#ddd'}`,
                                  transition: 'all 0.2s ease'
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id={`perm-edit-${pagina.nome}`}
                                  checked={paginasSelecionadas[pagina.nome]}
                                  onChange={() => handlePaginaChange(pagina.nome)}
                                  disabled={loading || isGerenteTI}
                                  style={{ 
                                    width: 16, 
                                    height: 16, 
                                    cursor: isGerenteTI ? 'not-allowed' : 'pointer',
                                    accentColor: 'rgb(235, 133, 0)',
                                    filter: 'hue-rotate(0deg) brightness(1.1)'
                                  }}
                                />
                                <label 
                                  htmlFor={`perm-edit-${pagina.nome}`}
                                  style={{ 
                                    fontSize: 13, 
                                    color: '#333',
                                    cursor: isGerenteTI ? 'not-allowed' : 'pointer',
                                    userSelect: 'none',
                                    flex: 1
                                  }}
                                >
                                  {pagina.label}
                                </label>
                              </div>
                            ))}
                          </div>
                          
                          <small className="form-hint" style={{ marginTop: 8, display: 'block', color: '#333' }}>
                            {PAGINAS_SISTEMA.filter(p => paginasSelecionadas[p.nome]).length} de {PAGINAS_SISTEMA.length} páginas selecionadas
                            {isGerenteTI && ' + 2 páginas de gerenciamento de funcionários'}
                            {isGerente && Object.values(permissoesFuncionarios).filter(v => v).length > 0 && 
                              ` + ${Object.values(permissoesFuncionarios).filter(v => v).length} página(s) de gerenciamento de funcionários`
                            }
                          </small>
                        </>
                      );
                    })()
                  )}
                </div>
              )}

              {/* Botões */}
              <div className="popup-actions">
                <button type="button" className="btn-cancelar" onClick={handleClosePopups} disabled={loading}>
                  Cancelar
                </button>
                <button type="submit" className="btn-criar-conta" disabled={loading}>
                  {loading ? 'Salvando...' : 'Salvar Alterações'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Popup de Alterar Senha */}
      {showPasswordPopup && selectedFuncionario && (
        <div className="popup-overlay" onClick={handleClosePopups}>
          <div className="popup-content popup-senha" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={handleClosePopups}>×</button>
            
            <div className="popup-header">
              <h3>Alterar Senha</h3>
              <p>Alterar senha de: <strong>{selectedFuncionario.login}</strong></p>
            </div>

            {error && <div className="popup-error">{error}</div>}
            {success && <div className="popup-success">{success}</div>}

            <form onSubmit={handleSavePassword} className="popup-form">
              <div className="form-section">
                <div className="form-group">
                  <label htmlFor="novaSenha">Nova Senha *</label>
                  <div className="input-with-icon">
                    <input 
                      id="novaSenha" 
                      name="novaSenha" 
                      type={showPassword ? 'text' : 'password'} 
                      value={passwordFormData.novaSenha} 
                      onChange={handlePasswordChange} 
                      placeholder="Digite a nova senha"
                      required 
                      disabled={loading} 
                    />
                    <button type="button" onClick={() => setShowPassword(s => !s)} className="password-toggle" aria-label="Mostrar senha">
                      {showPassword ? (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                          <path d="M3 3l18 18" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M17.94 17.94A10.95 10.95 0 0 1 12 20c-5 0-9.27-3-11-8 1.1-2.9 3.2-5.2 5.7-6.6" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M9.88 9.88a3 3 0 0 0 4.24 4.24" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      ) : (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                          <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <circle cx="12" cy="12" r="3" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      )}
                    </button>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="confirmarSenha">Confirmar Nova Senha *</label>
                  <div className="input-with-icon">
                    <input 
                      id="confirmarSenha" 
                      name="confirmarSenha" 
                      type={showPassword ? 'text' : 'password'} 
                      value={passwordFormData.confirmarSenha} 
                      onChange={handlePasswordChange} 
                      placeholder="Confirme a nova senha"
                      required 
                      disabled={loading} 
                    />
                  </div>
                </div>

                <ul className="password-rules">
                  {passwordRules(passwordFormData.novaSenha).map(rule => (
                    <li key={rule.id} className={`password-rule ${rule.ok ? 'valid' : 'invalid'}`}>
                      {rule.ok ? '✓' : '●'} {rule.label}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Botões */}
              <div className="popup-actions">
                <button type="button" className="btn-cancelar" onClick={handleClosePopups} disabled={loading}>
                  Cancelar
                </button>
                <button 
                  type="submit" 
                  className="btn-criar-conta" 
                  disabled={loading || !passwordRules(passwordFormData.novaSenha).every(r => r.ok) || passwordFormData.novaSenha !== passwordFormData.confirmarSenha}
                >
                  {loading ? 'Alterando...' : 'Alterar Senha'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Popup de Confirmação de Exclusão */}
      {showDeletePopup && selectedFuncionario && (
        <div className="popup-overlay" onClick={handleClosePopups}>
          <div className="popup-content popup-delete" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={handleClosePopups}>×</button>
            
            <div className="popup-header">
              <h3>Confirmar Exclusão</h3>
            </div>

            {error && <div className="popup-error">{error}</div>}
            {success && <div className="popup-success">{success}</div>}

            <div className="delete-confirmation">
              <p>Tem certeza que deseja excluir o funcionário:</p>
              <p className="delete-name"><strong>{selectedFuncionario.login}</strong></p>
              <p className="delete-warning">Esta ação não pode ser desfeita!</p>
            </div>

            <div className="popup-actions">
              <button type="button" className="btn-cancelar" onClick={handleClosePopups} disabled={loading}>
                Cancelar
              </button>
              <button 
                type="button" 
                className="btn-remover-confirm" 
                onClick={handleConfirmDelete}
                disabled={loading}
              >
                {loading ? 'Excluindo...' : 'Confirmar Exclusão'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
